module.exports = __webpack_public_path__ + "img/huandeng01.2174b131.png";